import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClear = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 10,
	fill: "#323338",
	viewBox: "0 0 17 17",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_7458",
		"data-name": "Path 7458",
		d: "M22.03,5.8a1.284,1.284,0,0,0-1.818,0l-6.3,6.292-6.3-6.3A1.286,1.286,0,0,0,5.785,7.6l6.3,6.3-6.3,6.3A1.286,1.286,0,0,0,7.6,22.03l6.3-6.3,6.3,6.3a1.286,1.286,0,0,0,1.818-1.818l-6.3-6.3,6.3-6.3A1.292,1.292,0,0,0,22.03,5.8Z",
		transform: "translate(-5.407 -5.407)"
	})
});
export { SvgClear as ReactComponent };
